//helper.js
export const IS_QA = String(process.env.MODE || "").toLowerCase() === "qa";
export const findUserInputType = (input) => {
    const hasNumbers = /\d/.test(input);
    const hasAtSymbol = input?.includes("@");
    if (hasAtSymbol)
      return "email"
    else if (hasNumbers)
      return "lillyId"
    else
      return "name"
  }



  export const descendingComparator=(a, b, orderBy)=> {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  export const getComparator=(order, orderBy) =>{
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  export const stableSort=(array, comparator) =>{
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const orderComp = comparator(a[0], b[0]);
      if (orderComp !== 0) return orderComp;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  export const stringToBoolean=(string)=> {
    const map ={
      "true": true,
      "false": false
    };
    return map[string.toLowerCase()];
  }
  
export const statusTagProps = (status = "") => {
  const s = status.toLowerCase();
  if (s === "completed") return { color: "green", children: "Completed" };
  if (s === "in progress") return { color: "blue", children: "In Progress" };
  if (s === "terminated") return { color: "orange", children: "Terminated" };
  if (s === "failed") return { color: "red", children: "Failed" };
  return { children: status || "Unknown" };
};

export const isValidScaffoldSmiles = (value, { minLength = 3, requireGrowthPoint = true } = {}) => {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (trimmed.length < minLength) return false;
  if (requireGrowthPoint && !trimmed.includes("*")) return false;
  return true;
};

export const BACKEND_CHUNK_SIZE = 10_000;
export const SERVER_FILTER_THRESHOLD = 10_000;
export const ROWS_PER_PAGE_OPTIONS = [
  { label: "20", value: 20 },
  { label: "40", value: 40 },
  { label: "60", value: 60 },
  { label: "80", value: 80 },
];
export const DEFAULT_ROWS = 20;

// export const ALL_COLUMNS = [
//     { key: "molecule_id", title: "Molecule ID", defaultVisible: true, disabled: true,  fixed: "left",
//     sorter: (a, b) =>
//       String(a.molecule_id).localeCompare(String(b.molecule_id)), },
//     { key: "smile", title: "SMILE String", defaultVisible: true, disabled: true, width: 250 },
//     { key: "structure_2d", title: "2D Structure", defaultVisible: true, disabled: true, width: 100 },
//     { key: "reward", title: "Reward", defaultVisible: true, disabled: false, width: 100, sorter: (a, b) => parseFloat(a.reward || 0) - parseFloat(b.reward || 0), },
//     // New Columns
//     { key: "glide", title: "Glide", defaultVisible: true, disabled: false, width: 180 },
//     { key: "phase_screen", title: "Phase Screen", defaultVisible: true, disabled: false, width: 220 },
//     // Other potential columns from your data
//     { key: "w_nchiral", title: "w_nchiral", defaultVisible: false, disabled: false },
//     { key: "w_lrsz", title: "w_lrsz", defaultVisible: false, disabled: false },
//     { key: "w_amw", title: "w_amw", defaultVisible: false, disabled: false },
//     { key: "w_halogen", title: "w_halogen", defaultVisible: false, disabled: false },
// ];

export const NUMERIC_COL_WIDTH = 80; // Default width for numeric columns


export const PARENT_LABELS = {
  molprops: "Molecular Properties",
  glide: "Glide Docking",
  phase: "Pharmacophore Screening",
  adme: "ADME Properties",
  molecule_id: "Molecule ID",
  reward: "Reward",
};

export const OPS_NUMERIC = [
  { label: "=", value: "eq" },
  { label: "!=", value: "neq" },
  { label: ">", value: "gt" },
  { label: ">=", value: "gte" },
  { label: "<", value: "lt" },
  { label: "<=", value: "lte" },
];
export const OPS_TEXT = [
  { label: "contains", value: "contains" },
  { label: "=", value: "eq" },
  { label: "!=", value: "neq" },
];

export const isAllChild = (val) => typeof val === "string" && val.endsWith("::ALL");


/* ---------------- helpers ---------------- */

// export 

export const formatBool = (v) => (v === true ? "True" : v === false ? "False" : v);

/* ------------- central columns registry ------------- */

export const ALL_COLUMNS = [
  { key: "molecule_id", title: "Molecule ID", defaultVisible: true, disabled: true, width: 100 },
  { key: "structure_2d", title: "2D Structure", defaultVisible: true, disabled: true, width: 200, align: "center" },
  { key: "smile", title: "SMILES", defaultVisible: true, disabled: false, width: 250 },
  { key: "reward", title: "Reward", defaultVisible: true, disabled: false, width: 80, align: "right" },

  // grouped jobs
  { key: "glide", title: "Glide Docking", isGroup: true, defaultVisible: true, disabled: false, width: 400 },
  { key: "phase", title: "Pharmacophore Screening", isGroup: true, defaultVisible: true, disabled: false, width: 400 },
  { key: "adme",  title: "ADME Properties", isGroup: true, defaultVisible: true, disabled: false, width: 420 },

  // NEW: Molecular Properties group (contains all w_* keys)
  { key: "molprops", title: "Molecular Properties", isGroup: true, defaultVisible: true, disabled: false, width: 420 },
];

export const ALWAYS_VISIBLE = ALL_COLUMNS.filter((c) => c.disabled).map((c) => c.key);
export const PINNED_KEYS = ["molecule_id", "structure_2d", "smile", "reward"];

export const COL_POPOVER_WIDTH = 1000;
export const CHILD_LABEL_WIDTH = 220;
export const GRID_COL_WIDTH = 70;




